module.exports = __webpack_public_path__ + "static/media/Remoraid_gaussian2.a05ef241.png";